import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import SustainabilityHeader from './components/SustainabilityHeader';
import KPIMetricsSection from './components/KPIMetricsSection';
import EmissionsChart from './components/EmissionsChart';
import SustainabilityGoalsTracker from './components/SustainabilityGoalsTracker';
import EnergyConsumptionChart from './components/EnergyConsumptionChart';
import ComplianceMatrix from './components/ComplianceMatrix';
import ReportGenerationPanel from './components/ReportGenerationPanel';

const SustainabilityAnalyticsHub = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('q3-2024');
  const [selectedFacility, setSelectedFacility] = useState('all');
  const [selectedFramework, setSelectedFramework] = useState('gri');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate data loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [selectedPeriod, selectedFacility, selectedFramework]);

  const handleExportReport = async () => {
    // Simulate report export
    return new Promise(resolve => {
      setTimeout(() => {
        console.log('Exporting sustainability report...');
        resolve();
      }, 2000);
    });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="pt-16">
          <div className="flex items-center justify-center h-96">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
              <span className="text-muted-foreground">Loading sustainability data...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="pt-16">
        {/* Page Header */}
        <SustainabilityHeader
          selectedPeriod={selectedPeriod}
          onPeriodChange={setSelectedPeriod}
          selectedFacility={selectedFacility}
          onFacilityChange={setSelectedFacility}
          selectedFramework={selectedFramework}
          onFrameworkChange={setSelectedFramework}
          onExportReport={handleExportReport}
        />

        {/* Main Content */}
        <div className="p-6 space-y-8">
          {/* KPI Metrics Section */}
          <KPIMetricsSection />

          {/* Main Dashboard Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-8">
            {/* Emissions Chart - 8 columns */}
            <div className="xl:col-span-8">
              <EmissionsChart />
            </div>

            {/* Sustainability Goals Tracker - 4 columns */}
            <div className="xl:col-span-4">
              <SustainabilityGoalsTracker />
            </div>
          </div>

          {/* Energy Consumption Chart */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
            <EnergyConsumptionChart />
            <ReportGenerationPanel />
          </div>

          {/* Compliance Matrix - Full Width */}
          <ComplianceMatrix />
        </div>
      </div>
    </div>
  );
};

export default SustainabilityAnalyticsHub;